module.exports = function getResource(label, vars = []) {
    const resources = {
        accept: 'Accepter',
        termsConditions: 'Modalités',
        mustAcceptTermsConditions: 'Vous devez d’abord accepter les conditions.',
        alreadyEnrolledFlash: 'Vous êtes déjà inscrit à Flash.',
        buttonCTAEnrolled: 'Déjà inscrit',
        buttonCTAEnrollNow: 'S’inscrire',
        flashTermsModalTitle: 'Conditions générales de Flash'
    };
    return resources[label];
};
